import React, { createContext, useContext, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Box, Stack, Button } from "@mui/material";
import CloseIcon from "../Icons/CloseIcon.svg";
import SuccessIcon from "../Icons/SuccessTickIcon.svg";
import UnableIcon from "../Icons/UnableIcon.svg";
import { StyledTypography, TypographyDefault } from "../Theme";
import { useNavigate } from "react-router-dom";

const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    content: "",
    actions: null,
    icon: "success",
  });
  const navigate = useNavigate();

  const showDialog = ({ title, content, actions, icon }) => {
    setDialog({
      open: true,
      title,
      content,
      actions: actions || null,
      icon: icon || "success",
    });
  };

  console.log("dialog", dialog);

  const closeDialog = () => {
    setDialog({ ...dialog, open: false });
  };

  return (
    <DialogContext.Provider value={{ showDialog, closeDialog }}>
      {children}
      <Dialog
        PaperProps={{
          sx: {
            width: "432px",
            overflowX: "hidden",
            borderRadius: " 8px",
          }, // Set width and prevent horizontal overflow
        }}
        open={dialog.open}
        onClose={closeDialog}
      >
        <Stack width="100%">
          <Box pt="10px" px="10px" display="flex" justifyContent={"flex-end"}>
            <img
              src={CloseIcon}
              alt="Custom Icon"
              style={{ cursor: "pointer" }}
              onClick={closeDialog}
            />
          </Box>
          <Stack gap="12px" px="40px" py="50px">
            <Stack alignItems={"center"} gap="10px">
              <img
                src={dialog?.icon === "success" ? SuccessIcon : UnableIcon}
                style={{ width: "60px", height: "60px" }}
                alt="Success Icon"
              />
              <StyledTypography
                sx={{
                  fontSize: "24px !important",
                  fontWeight: "500 !important",
                  letterSpacing: "-0.5px !important",
                }}
              >
                {dialog?.title}
              </StyledTypography>
            </Stack>
            <Stack alignItems={"center"} gap="36px">
              <TypographyDefault sx={{ textAlign: "center" }}>
                {dialog?.content}
              </TypographyDefault>
              {dialog?.actions || (
                <Button
                  type="button"
                  sx={{ width: "fit-content" }}
                  variant="Standard"
                  onClick={() => {
                    navigate("/sales-overview");
                    closeDialog();
                  }}
                >
                  Return to Dashboard
                </Button>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Dialog>
    </DialogContext.Provider>
  );
};

// Custom hook for accessing dialog
export const useDialog = () => useContext(DialogContext);
